import React, { useState, useEffect, useMemo } from "react";
import {
  Row,
  Col,
  Tabs,
  Input,
  Typography,
  Button,
  message,
  Tag,
  Select,
  Pagination,
  Table,
  Space,
  Switch,
  Spin,
} from "antd";
import { MailOutlined, EditOutlined } from "@ant-design/icons";

import { Popup } from "../../../atoms/Popup";
import SectionHeader from "../../../molecules/SectionHeader";
import { maintenanceService } from "../../../../configs/constants";
import axios from "../../../../utils/axiosInceptor";
import { useSelector, useDispatch } from "react-redux";

import AddTechnician from "./components/AddTechnician";
import ApproveTechnician from "./components/ApproveTechnician";
import RejectTechnician from "./components/RejectTechnician";
import WarnInactiveTechnicial from "./components/SendInviteToTenant";

import { getAllTechnicians, invite, getMaintananceCategories } from "./ducks/actions";
import DashboardLayout from "../../../molecules/DashboardLayout";
import BreadCrumb from "../../../atoms/BreadCrumb";
import AddRemoveSpecialzation from "./components/AddRemoveSpecialzation";
import EditTechnician from "./components/EditTechnician";

import { getListZones } from "../Zones/ducks/actions";

var _ = require("lodash");
const { Title } = Typography;

const breadcrumbList: any = [
  {
    label: "Maintenance",
    route: "/technicians",
  },
  {
    label: "Technicians",
    route: "/technicians",
  },
];

const limit = 20;

export default () => {
  const dispatch: any = useDispatch();
  const techlistApi = useSelector((state: any) => state.technicians.techData);
  const [visible, setVisible] = useState(false);
  const [warnVisible, setWarnVisible] = useState(false);
  const [assignmentUser, setAssignmentUser] = useState(null);
  const [tid, setTID] = useState(null);
  const [trigger, setTrigger] = useState(0);
  const [page, setPage] = useState(1);
  const [techData, setTechData] = useState({});
  const [special, setSpecial] = useState([]);
  const [technicians, setTechnicians] = useState([]);
  const [techniciansAssigned, setTechniciansAssigned] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
  const [invites, setInvites] = useState<React.Key[]>([]);
  const [loader, setLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [zones, setZones] = useState([]);
  const [searchBy, setSearchBy] = useState(null);
  const [filters, setFilters] = useState({
    status: null,
    zoneId: null,
    categoryId: null,
    name: null,
  });

  const { categoriesList } = useSelector((state: any) => state.categories);

  const { residential, commercial, internal } = categoriesList;
  let initialValue = [{ label: "All", value: null }];

  let categories =
    Object.keys(categoriesList)?.length > 0
      ? [...initialValue, ...residential, ...commercial, ...internal]
      : initialValue;

  const onSelectChange = (newSelectedRowKeys, selectedRows) => {
    setSelectedRowKeys(newSelectedRowKeys);
    setInvites(selectedRows.map((row) => row.number));
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record?.isSignUp === "Yes",
    }),
  };

  const updateTechStatus = async (assignStatus?) => {
    setLoader(true);

    if (assignmentUser || assignStatus) {
      const postJson = {
        ticketAssignment: assignStatus ? "yes" : "no",
      };
      const userId = assignmentUser?.userId || assignStatus.userId;
      const url = `${maintenanceService}/technician/user/${userId}`;
      try {
        await axios.patch(url, postJson);
        setLoader(false);
        message.success("Technician updated successfully");
        setAssignmentUser(null);
        dispatch(getAllTechnicians(page, limit, filters, setLoading)); //PAGE
      } catch (e) {
        setLoader(false);
        setAssignmentUser(null);
      }
    }
  };

  const popupWarn = {
    title: (
      <Title level={3} className="mb-0">
        Warning
      </Title>
    ),
    content: (
      <WarnInactiveTechnicial
        title={`This technician will not be able to receive tickets. Are you sure?`}
        onCancel={() => {
          // setFormValues(null)
          setWarnVisible(false);
          setAssignmentUser(null);
        }}
        onConfirm={() => {
          setWarnVisible(false);
          updateTechStatus();
        }}
      />
    ),
    width: 650,
  };

  const popupWarnProps = {
    closable: true,
    visibility: warnVisible,
    title: popupWarn.title,
    content: popupWarn.content,
    width: popupWarn.width,
    onCancel: () => {
      setWarnVisible(false);
      setAssignmentUser(null);
    },
  };

  const assignTechCol = [
    {
      title: "Technician Name",
      dataIndex: "first_name",
      key: "name",
      width: 220,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: 220,
    },
    {
      title: "Mobile",
      dataIndex: "number",
      key: "number",
      width: 220,
    },
    {
      title: "Internal Categories",
      dataIndex: "internalCategories",
      key: "internalCategories",
      width: 220,
      render: (_, { internalCategories }) => {
        return (
          <>
            <span />
            {internalCategories?.map((tag) => {
              return (
                <Tag className="tag-sm" key={tag?._id}>
                  {tag?.name}
                </Tag>
              );
            })}
          </>
        );
      },
    },
    {
      title: "Residential Categories",
      dataIndex: "residentialCategories",
      key: "residentialCategories",
      width: 220,
      render: (_, { residentialCategories }) => {
        return (
          <>
            <span />
            {residentialCategories?.map((tag) => {
              return (
                <Tag className="tag-sm" key={tag?._id}>
                  {tag?.name}
                </Tag>
              );
            })}
          </>
        );
      },
    },
    {
      title: "Commercial Categories",
      dataIndex: "commercialCategories",
      key: "commercialCategories",
      width: 220,
      render: (_, { commercialCategories }) => {
        return (
          <>
            <span />
            {commercialCategories?.map((tag) => {
              return (
                <Tag className="tag-sm" key={tag?._id}>
                  {tag?.name}
                </Tag>
              );
            })}
          </>
        );
      },
    },
    {
      title: "Ticket Assignment",
      dataIndex: "ticketAssignment",
      key: "ticketAssignment",
      width: 220,
      render: (status, record) => {
        return (
          <Space size={4}>
            <div className="Simple-tooltip" style={{ fontSize: 20, paddingTop: 3 }}>
              <Switch
                className="switch"
                size="small"
                onChange={(e) => {
                  if (!e) {
                    setWarnVisible(true);
                    setAssignmentUser(record);
                  } else {
                    updateTechStatus(record);
                  }
                }}
                checked={status === "yes"}
              />
              <section className="tt-content">{status === "yes" ? `Yes` : "No"}</section>
            </div>
          </Space>
        );
      },
    },
    {
      title: "Registered",
      dataIndex: "isSignUp",
      key: "isSignUp",
      width: 220,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      width: 220,
      render: (text, record) => {
        return (
          <Space size={16}>
            <Button
              type="link"
              onClick={() => {
                if (record.isSignUp === "No") return sendInvite(record);
              }}
              className="p-0 ag-success"
            >
              {record.isSignUp === "No" ? (
                <div className="Simple-tooltip">
                  <MailOutlined />
                  <section className="tt-content">Send Invite</section>
                </div>
              ) : (
                <div>
                  <div className="Simple-tooltip">
                    <MailOutlined style={{ color: "grey" }} />
                    <section className="tt-content">Already Registered</section>
                  </div>
                </div>
              )}
            </Button>

            <Button
              type="link"
              onClick={() => {
                editTechnician(record);
              }}
              className="p-0 ag-success"
            >
              <div className="Simple-tooltip">
                <EditOutlined />
                <section className="tt-content">Edit Details</section>
              </div>
            </Button>
          </Space>
        );
      },
    },
  ];

  function onTopSearch(value) {
    if (searchBy) {
      setFilters((prev) => ({
        ...prev,
        name: value,
      }));
    }
  }

  useEffect(() => {
    dispatch(getAllTechnicians(1, limit, filters, setLoading));
    dispatch(getMaintananceCategories());
  }, [filters?.zoneId, filters?.status, filters?.name, filters?.categoryId]);

  // useEffect(() => {
  //   (techlistApi && techlistApi?.length > 0) ? setTechnicians(techlistApi.data) : setTechnicians([]);
  // }, [techlistApi,technicians]);

  useEffect(() => {
    (techlistApi.data && techlistApi.data?.length) > 0
      ? setTechniciansAssigned(
          techlistApi.data.map((item) => ({
            id: item?.userData[0]?._id,
            first_name: item?.userData[0]?.name,
            email: item?.userData[0]?.email,
            number: item?.userData[0]?.mobile,
            residentialCategories: item?.residentialCategories,
            internalCategories: item?.internalCategories,
            commercialCategories: item?.commercialCategories,
            userId: item?.userId,
            ticketAssignment: item?.ticketAssignment,
            isSignUp: item?.userData[0]?.isSignUp ? "Yes" : "No",
          }))
        )
      : setTechniciansAssigned([]);
  }, [techlistApi.data]);

  const onSubmit = () => {
    dispatch(getAllTechnicians(1, limit, filters, setLoading));
    setPage(1);
    setVisible(false);
    setTID(null);
    setSpecial([]);
  };

  const zoneApi = useSelector((state: any) => state.zones.zonesData);

  const onPageChange = (e) => {
    setPage(e);
    dispatch(getAllTechnicians(e, limit, filters, setLoading));
  };

  const onAddTechnician = () => {
    setTechData({});
    setTrigger(4);
  };

  useEffect(() => {
    if (zoneApi?.data?.length > 0) {
      let zoneData = [{ label: "All", value: null }];
      zoneApi?.data?.forEach((element) => {
        zoneData.push({
          value: element.zoneId,
          label: element.name,
        });
      });
      setZones(zoneData);
    }
  }, [zoneApi]);

  const popup = [
    {
      title: (
        <Title level={3} className=" mb-0">
          Add New Technician
        </Title>
      ),
      content: (
        <AddTechnician onAddTechnician={onAddTechnician} onCancel={() => setVisible(false)} onSubmit={onSubmit} />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          New Technician Request Approval
        </Title>
      ),
      content: (
        <ApproveTechnician
          data={techData}
          onReject={rejectTechnician}
          onCancel={() => setVisible(false)}
          onApprove={onSubmit}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className=" mb-0">
          Reason for Rejection
        </Title>
      ),
      content: <RejectTechnician data={techData} onReject={onSubmit} onBack={() => setTrigger(1)} />,
      width: 650,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          Add/Remove Specialization
        </Title>
      ),
      content: (
        <AddRemoveSpecialzation
          // onAddTech={onAddTech}
          data={special}
          id={tid}
          onCancel={() => {
            setVisible(false);
            setSpecial([]);
          }}
        />
      ),
      width: 650,
    },
    {
      title: (
        <Title level={3} className="mb-0">
          {techData && Object.keys(techData).length === 0 && techData.constructor === Object
            ? "Add Technician"
            : "Edit technician details and assign shifts"}
        </Title>
      ),
      content: (
        <EditTechnician
          onUpdateTech={onSubmit}
          data={techData}
          onCancel={() => {
            setVisible(false);
            setTechData(null);
          }}
        />
      ),
      width: 950,
    },
  ];

  const popupProps = {
    closable: true,
    visibility: visible,
    title: popup[trigger].title,
    content: popup[trigger].content,
    width: popup[trigger].width,
    onCancel: () => setVisible(false),
  };

  function rejectTechnician() {
    setTrigger(2);
  }

  const addTechnician = () => {
    setVisible(true);
    setTrigger(0);
  };

  const editTechnician = (item) => {
    setVisible(true);
    setTechData(item);
    setTrigger(4);
  };

  const sendInvite = async ({ number }) => {
    let successMessage = "";
    setLoading(true);
    // let payload = {
    //   contacts: [],
    //   usertype: "technician",
    //   inviteAll: false,
    // };
    let payload = [];

    let contacts = {
      contacts: null,
      usertype: "technician",
      inviteAll: false,
    };
    if (number) {
      contacts.contacts = number;
      payload.push(contacts);
      successMessage = "Invite sent to technician successfully";
    } else if (selectedRowKeys.length > 0) {
      invites.forEach((number) => {
        contacts.contacts = number;
        payload.push(contacts);
      });
      setSelectedRowKeys([]);
      successMessage = "Invite sent to selected technician successfully";
    } else {
      contacts.inviteAll = true;
      contacts.contacts = [];
      payload.push(contacts);
      successMessage = "Invite sent to all technician successfully";
    }

    const status = await invite(payload, successMessage);
    setLoading(false);
    if (status) {
      message.success(successMessage);
      setSelectedRowKeys([]);
    } else {
      message.error("Error in sending Invite.");
    }
  };

  const filterOptions = [
    {
      name: `category`,
      label: "Category",
      initialValue: "All",
      options: categories,
      search: true,
    },
    {
      name: "zone",
      label: "Zone",
      search: true,
      initialValue: "All",
      options: zones,
    },
    {
      name: "status",
      label: "Status",
      search: true,
      initialValue: "All",
      options: [
        {
          label: "All",
          value: null,
        },
        {
          value: "enable",
          label: "Active",
        },
        {
          value: "disable",
          label: "Inactive",
        },
      ],
    },
  ];

  const searchOptions = useMemo(() => {
    return [
      {
        name: `technicianName`,
        label: "Technician Name",
        value: "technicianName",
      },
    ];
  }, []);

  const filtershandler = (value, name) => {
    if (name === "status") {
      setFilters((prev) => ({
        ...prev,
        status: value?.value,
      }));
    } else if (name === "zone") {
      setFilters((prev) => ({
        ...prev,
        zoneId: value?.value,
      }));
    } else if (name === "category") {
      setFilters((prev) => ({
        ...prev,
        categoryId: value?.value,
      }));
    }
  };

  useEffect(() => {
    if (zoneApi?.length == 0) dispatch(getListZones(1, 1000, ""));
  }, []);
  return (
    <>
      <DashboardLayout load={loading}>
        {loader && (
          <Row gutter={[24, 24]}>
            <Col span={24}>
              <Space size={24} className="w-100 text-center" direction="vertical">
                <Spin size="large" className="ag-fontSize32" />
              </Space>
            </Col>
          </Row>
        )}
        <Row gutter={[24, 24]}>
          <Col span={24}>
            <BreadCrumb list={breadcrumbList} />
          </Col>
        </Row>

        <Row gutter={24}>
          <Col span={24}>
            <SectionHeader
              heading="Technicians"
              isDisabled={!(techniciansAssigned?.length > 0)}
              total={techlistApi?.totalCount}
              viewOption={filterOptions}
              handleView={(e, name) => filtershandler(e, name)}
              search={onTopSearch}
              searchOptions={searchOptions}
              searchBy={(e) => setSearchBy(e?.value)}
              addNewAction={addTechnician}
              addMoreButton={sendInvite}
              justifyEnd={true}
              viewOptionColumn={12}
              addMoreText={selectedRowKeys.length > 0 ? "Invite Selected" : "Invite All"}
            />
            <Row gutter={[24, 24]}>
              <Col span={24}>
                <Row gutter={[20, 20]} justify="end">
                  <Col span={24}>
                    <Pagination
                      pageSize={20}
                      current={page}
                      defaultCurrent={1}
                      showSizeChanger={false}
                      total={techlistApi?.totalCount}
                      onChange={(e) => onPageChange(e)}
                      className="ag-property-text-pagination"
                      showTotal={(total, range) => `Showing ${range[0]}-${range[1]} of ${total} Service Providers`}
                    />
                  </Col>

                  <Col span={24}>
                    <Table
                      columns={assignTechCol}
                      scroll={{ y: 500 }}
                      rowKey={(record, index) => index}
                      dataSource={techniciansAssigned}
                      rowSelection={rowSelection}
                      className="custom-table org_table_wrap"
                      pagination={false}
                    />
                  </Col>
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </DashboardLayout>
      <Popup destroyOnClose={true} {...popupProps} />
      <Popup destroyOnClose={true} {...popupWarnProps} />
    </>
  );
};
